import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,_vm._g({staticClass:"mt-5",staticStyle:{"bottom":"40px"},attrs:{"mt-5":"","fab":"","right":"","bottom":"","fixed":"","color":"primary"},on:{"click":function($event){return _vm.$emit('click')}}},_vm.on),[_c(VIcon,[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }